import { List, ListItem } from '@chakra-ui/react';
import { Checkbox, Colors, Text } from '@mercator-gcp/grout';
import { FlexColumn } from 'components/layout/FlexColumn/FlexColumn';
import { SidebarSectionLabel } from 'components/layout/SidebarLayout';
import { useCompanyTypeFilterState } from 'state/filterCompanies';
import { COMPANY_TYPES } from 'utils/constants/companyTypes';
import { renameDocuments } from 'utils/renameDocuments';

const optionStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  paddingLeft: 'padding_8',
  paddingRight: 'padding_8',
  '&:hover': {
    background: Colors.ArmyGreen100,
    cursor: 'pointer',
  },
};

const checkboxStyle = {
  width: '100%',
  paddingTop: 'padding_8',
  paddingBottom: 'padding_8',
};

const CompanyTypeFilter = () => {
  const { companyTypeFilter, setCompanyTypeFilter } = useCompanyTypeFilterState();

  const handleToggle = (value: string) => {
    let newSelections: string[] = [];

    if (companyTypeFilter.includes(value)) {
      newSelections = companyTypeFilter.filter((item) => item !== value);
    } else {
      newSelections = [...companyTypeFilter, value];
    }

    setCompanyTypeFilter(newSelections);
  };

  return (
    <FlexColumn>
      <SidebarSectionLabel label="Type" />
      <List>
        {COMPANY_TYPES.map((option) => {
          return (
            <ListItem sx={optionStyle} key={`latest-stage-option-${option.value}`}>
              <Checkbox
                value={option.value}
                sx={checkboxStyle}
                onToggle={() => handleToggle(option.value)}
                isChecked={companyTypeFilter.includes(option.value)}
              >
                <Text>{renameDocuments(option.label)}</Text>
              </Checkbox>
            </ListItem>
          );
        })}
      </List>
    </FlexColumn>
  );
};

export default CompanyTypeFilter;
